import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Heading } from '@elseu/sdu-titan';
import styled from 'styled-components';
import { Button } from '../Button/Button.js';

/**
 * The container for the button
 */
var ButtonContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[4];
});
/**
 * The Content component
 */
var StyledContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n  align-items: center;\n  width: 100%;\n\n  > p,\n  > ul,\n  > ol,\n  > h3,\n  > h4,\n  > .", " {\n    width: 100%;\n    max-width: calc(768px - ", ");\n  }\n\n  & > img {\n    height: auto;\n    align-self: center;\n    width: 100%;\n    max-width: 1200px;\n    padding: ", ";\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n  align-items: center;\n  width: 100%;\n\n  > p,\n  > ul,\n  > ol,\n  > h3,\n  > h4,\n  > .", " {\n    width: 100%;\n    max-width: calc(768px - ", ");\n  }\n\n  & > img {\n    height: auto;\n    align-self: center;\n    width: 100%;\n    max-width: 1200px;\n    padding: ", ";\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: ", ";\n  }\n"])), ButtonContainer.styledComponentId, function (_a) {
  var theme = _a.theme;
  return theme.spacing[8];
}, function (_a) {
  var theme = _a.theme;
  return "".concat(theme.spacing[8], " 0");
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[8];
});
/**
 * The Content component
 *
 * @param {ContentProps} props - The props for the Content component.
 * @returns {JSX.Element} The Content component.
 */
var Content = function (_a) {
  var children = _a.children,
    title = _a.title,
    button = _a.button;
  return jsxs(StyledContent, {
    children: [title && jsx(Heading, {
      heading: "h3",
      spaceAfter: 8,
      children: title
    }), children, button && jsx(ButtonContainer, {
      children: jsx(Button, __assign({}, button, {
        isExternal: button.external
      }))
    })]
  });
};
var templateObject_1, templateObject_2;

export { Content, StyledContent };
//# sourceMappingURL=Content.js.map
